import { LayoutDashboard, Clock, TrendingUp, AlertTriangle, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Panoramica generale d'agenzia (placeholder).
 *
 * Sarà la dashboard cross-reparto dove il team Salon Up monitora urgenze,
 * task in scadenza, progetti in ballo, KPI agenzia. Per ora è un placeholder
 * con quick-links ai moduli principali.
 */
export default function AdminOverview() {
  return (
    <div data-testid="admin-overview-page" className="space-y-6">
      <header>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight flex items-center gap-3">
          <LayoutDashboard className="h-9 w-9 text-[color:var(--sp-brand)]" /> Panoramica agenzia
        </h1>
        <p className="text-[color:var(--sp-text-secondary)] mt-2 max-w-2xl">
          Dashboard cross-reparto: urgenze del giorno, clienti da seguire, KPI aggregati.
        </p>
      </header>

      <div className="sp-card p-8 border-l-4 border-amber-500 bg-amber-50/60 flex items-start gap-4">
        <Sparkles className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <div className="font-display text-lg font-black text-amber-900">Placeholder — sezione in costruzione</div>
          <p className="text-sm text-amber-900/80 mt-1 max-w-xl">
            Qui arriveranno urgenze giornaliere, clienti da seguire, KPI d'agenzia
            (churn, MRR, saloni attivi). Definiremo il layout insieme
            nella prossima iterazione.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <QuickCard to="/admin/clienti" icon={Clock} label="Clienti" desc="Saloni che seguiamo" testid="quick-clienti" />
        <QuickCard to="/admin/comparison" icon={TrendingUp} label="Confronto Saloni" desc="Panoramica clienti gestiti" testid="quick-comparison" />
        <QuickCard to="/admin/inbox" icon={AlertTriangle} label="Inbox" desc="Ultimi messaggi agenzia" testid="quick-inbox" />
      </div>
    </div>
  );
}

function QuickCard({ to, icon: Icon, label, desc, testid }) {
  return (
    <Link to={to} data-testid={testid}
      className="sp-card p-6 hover:border-[color:var(--sp-brand)] transition-colors group block">
      <div className="w-11 h-11 rounded-full bg-[color:var(--sp-brand)]/10 flex items-center justify-center mb-3 group-hover:bg-[color:var(--sp-brand)]/20 transition-colors">
        <Icon className="h-5 w-5 text-[color:var(--sp-brand)]" />
      </div>
      <div className="font-display text-lg font-black">{label}</div>
      <div className="text-xs text-[color:var(--sp-text-secondary)] mt-1">{desc}</div>
    </Link>
  );
}
